import React from 'react';
import { FilterSelect } from '../../commonComponents/filters/FilterSelect';
import { SelectFilter } from '../../commonComponents/filters/SelectFilter';
import { stateFilterOptions } from '../../../utils/filters';
import { LICENSE_FILTERS_V2 } from './utils';

// State keeps the StatePicker semantics it replaces: "All" is '', not 'all'.
const STATE_OPTIONS = stateFilterOptions('');

/** The Licenses list's filter fields, for ListPage's `filters` card. */
export const Filters = ({ filter, handleFilterChange }) => (
  <>
    <SelectFilter
      label="State"
      options={STATE_OPTIONS}
      value={filter.state}
      onChange={(state) => handleFilterChange('state', state)}
    />

    {LICENSE_FILTERS_V2().map(({ key, label, options }) => (
      <FilterSelect
        key={key}
        id={key}
        label={label}
        options={options}
        value={filter[key]}
        onChange={handleFilterChange}
      />
    ))}
  </>
);
